import type { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';
import { axiosInstance } from '@shared/lib/axios';
import type { TAxiosError } from '@shared/lib/types';
import { MUTATIONS_INFO } from '@shared/lib/const';
export type TNewLoginPayload = {
  email: string;
};
export const useRequestToChangeLoginCurrentUser = () => useMutation<AxiosResponse<string>, TAxiosError, TNewLoginPayload>((payload: TNewLoginPayload) => axiosInstance.post(MUTATIONS_INFO.requestToApplyNewLoginCurrentUser, payload));